import { render } from "./CardMembreExpanded.vue?vue&type=template&id=12642c56"
import script from "./CardMembreExpanded.vue?vue&type=script&lang=js"
export * from "./CardMembreExpanded.vue?vue&type=script&lang=js"

import "./CardMembreExpanded.vue?vue&type=style&index=0&id=12642c56&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__